import React from 'react';

/** The shared under-card glow, anchored to each card's h-[78px] slot. */
export const CardGlow: React.FC = () => (
  <div
    aria-hidden="true"
    className="absolute -bottom-[13px] left-[11%] h-[21px] w-[78%] rounded-full bg-[#d9d9d9] blur-[10px]"
  />
);
